import React, { useState, useEffect } from 'react';

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  
  const PASSWORD = 'ceavulcan2025';
  
  useEffect(() => {
    // Check if already authenticated
    const auth = sessionStorage.getItem('cea_auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      sessionStorage.setItem('cea_auth', 'true');
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
      setPassword('');
    }
  };
  
  if (isAuthenticated) {
    return children;
  }
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src="/vulcan-logo.png" 
            alt="Vulcan Logo" 
            style={{ 
              height: '80px', 
              width: 'auto',
              marginBottom: '16px'
            }} 
          />
        </div>
        <h2 style={{ textAlign: 'center', color: '#333', marginBottom: '30px' }}>
          Vulcan Regulatory Platform
        </h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              border: '2px solid #e0e0e0',
              borderRadius: '5px',
              marginBottom: '20px'
            }}
            autoFocus
          />
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Access Platform
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordProtection;